import React from 'react';

export default (props) => (
  <div className="presenter">
    {props.image && <img className="portrait" src={props.image.resize.src} alt={props.name} />}
    <div className="name">{props.name}</div>
  </div>
);
